export enum DELIVERY_METHOD {
    PROGRAMMATIC = 'PROGRAMMATIC',
    ADNETWORK = 'ADNETWORK',
    DIRECT = 'DIRECT',
    PROGRAMMATIC_ADNETWORK = 'PROGRAMMATIC_ADNETWORK',
    PROGRAMMATIC_DIRECT = 'PROGRAMMATIC_DIRECT',
    HOUSEAD = 'HOUSEAD',
}
